let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5DL2O")).then(() => parcelRequire('kg6Vu'));